import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const PrivateRoute = () => {
  const { isAuth } = useSelector((state) => state.auth);
  const location = useLocation();
  
  if (!isAuth) {
    // Save the location we were trying to access
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <Outlet />;
};
